import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Star, ArrowLeft, CheckCircle } from 'lucide-react';
import { api } from '../config/api';

const ReviewPage = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const res = await api.get(`/orders.php?order_id=${orderId}`);
        if (res.data.success) setOrder(res.data.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchOrder();
  }, [orderId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!comment.trim()) { setError('Please write your review.'); return; }
    try {
      const user = JSON.parse(localStorage.getItem('user') || 'null');
      const res = await api.post('/reviews.php', {
        rating,
        comment,
        order_id: parseInt(orderId, 10),
        user_id: user?.user_id || null,
        name: user?.name || ''
      });
      if (res.data.success) { setSubmitted(true); } else { setError(res.data.message || 'Failed to submit review'); }
    } catch (err) {
      setError('Failed to submit review. Please try again.');
    }
  };

  if (!order) {
    return (
      <div style={{ backgroundColor: '#faf8f5', minHeight: '100vh', paddingTop: '100px', paddingBottom: '60px' }}>
        <div className="container" style={{ maxWidth: '600px', textAlign: 'center' }}>
          <p style={{ color: '#999' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <div style={{ backgroundColor: '#faf8f5', minHeight: '100vh', paddingTop: '100px', paddingBottom: '60px' }}>
        <div className="container" style={{ maxWidth: '600px' }}>
          <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '40px', textAlign: 'center', border: '1px solid #EAEDF1' }}>
            <CheckCircle size={48} color="#4CAF50" style={{ marginBottom: '16px' }} />
            <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.8rem', fontWeight: 600, color: '#1A1A1A', marginBottom: '8px' }}>Thank You!</h2>
            <p style={{ color: '#666', marginBottom: '24px' }}>Your review has been submitted and will appear once approved by our team.</p>
            <Link to="/my-orders" className="btn btn-gold">Back to My Orders</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#faf8f5', minHeight: '100vh', paddingTop: '100px', paddingBottom: '60px' }}>
      <div className="container" style={{ maxWidth: '600px' }}>
        <Link to="/my-orders" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', color: '#666', textDecoration: 'none', fontSize: '0.85rem', marginBottom: '20px' }}>
          <ArrowLeft size={16} /> Back to My Orders
        </Link>

        <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '32px', border: '1px solid #EAEDF1' }}>
          <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.6rem', fontWeight: 600, color: '#1A1A1A', marginBottom: '4px', textAlign: 'center' }}>Rate Your Experience</h2>
          <p style={{ color: '#999', fontSize: '0.9rem', textAlign: 'center', marginBottom: '24px' }}>Order #{order.order_id}</p>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px', textAlign: 'center' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#333', marginBottom: '8px', display: 'block' }}>Rating</label>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                {[1, 2, 3, 4, 5].map(star => (
                  <button key={star} type="button" onClick={() => setRating(star)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}>
                    <Star size={32} fill={star <= rating ? '#D4AF37' : 'none'} color={star <= rating ? '#D4AF37' : '#ddd'} />
                  </button>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#333', marginBottom: '8px', display: 'block' }}>Your Review</label>
              <textarea value={comment} onChange={e => setComment(e.target.value)} rows="5" placeholder="Tell us about your experience..."
                style={{ width: '100%', padding: '12px 16px', borderRadius: '10px', border: '1px solid #EAEDF1', fontSize: '0.9rem', resize: 'vertical', fontFamily: 'inherit' }} />
            </div>

            {error && <p style={{ color: '#E74C3C', fontSize: '0.85rem', marginBottom: '16px' }}>{error}</p>}

            <button type="submit" className="btn btn-gold" style={{ width: '100%', padding: '14px', fontSize: '0.9rem' }}>
              Submit Review
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReviewPage;
